<template>
    <div class="category-picker">
        <ul v-if="categories.length" class="category-list">
            <li v-for="category in categories" :key="category.id" class="category-list__item">
                {{ category.label[$i18n.locale] }}
                <button
                    type="button"
                    class="category-list__item-del"
                    @click.prevent="deleteCategory(category.id)"
                >
                    <svg
                        width="8"
                        height="8"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        style="pointer-events: none"
                    >
                        <path
                            d="M505.943 6.058c-8.077-8.077-21.172-8.077-29.249 0L6.058 476.693c-8.077 8.077-8.077 21.172 0 29.249A20.612 20.612 0 0020.683 512a20.614 20.614 0 0014.625-6.059L505.943 35.306c8.076-8.076 8.076-21.171 0-29.248z"
                        />
                        <path
                            d="M505.942 476.694L35.306 6.059c-8.076-8.077-21.172-8.077-29.248 0-8.077 8.076-8.077 21.171 0 29.248l470.636 470.636a20.616 20.616 0 0014.625 6.058 20.615 20.615 0 0014.624-6.057c8.075-8.078 8.075-21.173-.001-29.25z"
                        />
                    </svg>
                </button>
            </li>
        </ul>
        <div v-else class="category-picker__notice">{{ $t('bookEdit.category.empty') }}</div>
        <button class="category-picker__add-button" type="button" @click="showModal = true">
            {{ $t('bookEdit.category.add') }}
        </button>
        <portal to="modals">
            <Modal
                v-if="showModal"
                name="genre-picker"
                class="genre-modal"
                :title="$t('bookEdit.category.modalTitle')"
                @closed="showModal = false"
            >
                <template #content>
                    <form @submit.prevent="save">
                        <div class="category-type-list">
                            <div class="genre-list">
                                <Checkbox
                                    v-for="category in allCategories"
                                    :key="category.id"
                                    v-model="localCategoryIds"
                                    class="genre-list-item"
                                    :value="category.id"
                                    :label="category.label[$i18n.locale]"
                                />
                            </div>
                        </div>
                        <button type="submit" class="button button--big">
                            {{ $t('misc.save') }}
                        </button>
                    </form>
                </template>
            </Modal>
        </portal>
    </div>
</template>

<script>
import { Modal } from '@speechki-frontend/shared/ui/modals';
import { mapState } from 'vuex';
import { Checkbox } from '@speechki-frontend/shared/ui/forms';

export default {
    name: 'CategoryPicker',
    components: {
        Modal,
        Checkbox,
    },
    emits: ['update:modelValue'],
    props: {
        categories: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            localCategories: [],
            localCategoryIds: [],
            showModal: false,
        };
    },
    computed: {
        ...mapState({
            allCategories: (state) => state.book.categories,
        }),
    },
    watch: {
        categories: {
            immediate: true,
            handler() {
                this.localCategories = this.categories;
                this.localCategoryIds = this.categories.map((cat) => cat.id);
            },
        },
        localCategoryIds() {
            this.localCategories = this.allCategories.filter((cat) =>
                this.localCategoryIds.includes(cat.id)
            );
        },
    },
    methods: {
        save() {
            this.$emit('update:modelValue', this.localCategories);
            this.showModal = false;
        },
        deleteCategory(id) {
            this.localCategories = this.localCategories.filter((category) => category.id !== id);
            this.$emit('update:modelValue', this.localCategories);
        },
    },
};
</script>

<style lang="scss" src="./CategoryPicker.scss"></style>
